module.exports = __webpack_public_path__ + "img/video2-poster-pc.0912134c.png";